// バックエンドの検証 (Domain/SecretName.cs) と同じシークレット名の規則。名前は環境の bash に
// そのまま環境変数名として export されるため、POSIX の環境変数名に限定する。
// (この規則はバックエンド SecretName と同期すること)
export const SECRET_NAME_PATTERN = /^[A-Z_][A-Z0-9_]*$/;

const MAX_NAME_LENGTH = 64;
const RESERVED_PREFIX = "IZANAGI_";

/** シークレット名のエラーメッセージを返す。妥当ならば null。 */
export function secretNameError(name: string): string | null {
	const trimmed = name.trim();
	if (trimmed.length === 0) return "シークレット名は必須です。";
	if (trimmed.length > MAX_NAME_LENGTH)
		return `シークレット名は${MAX_NAME_LENGTH}文字以内にしてください。`;
	if (!SECRET_NAME_PATTERN.test(trimmed)) {
		return "大文字英字・数字・アンダースコアのみで、数字以外から始めてください (例: GITHUB_TOKEN)。";
	}
	if (trimmed.startsWith(RESERVED_PREFIX)) return `${RESERVED_PREFIX} で始まる名前は使えません。`;
	return null;
}

/** 改行区切りの許可ホスト入力を、空行を除いた配列にする。 */
export function parseHostList(text: string): string[] {
	return text
		.split("\n")
		.map((line) => line.trim())
		.filter((line) => line.length > 0);
}
